<template>
    <div v-if="saison">
        <v-data-table :headers="headers" :items="saison.local.tabelle" hide-default-header
                      :dense="dense" hide-default-footer mobile-breakpoint="1" disable-pagination
                      :class="[{'elevation-0': $vuetify.breakpoint.smAndDown},
                                {'elevation-4 mx-2': $vuetify.breakpoint.mdAndUp}]"> <!--mobile-breakpoint="0"-->
            <template v-slot:header="{}">
                <tr class="px-0 text-center" > <!--hide-default-header-->
                    <th :class="[{'py-4': dense}, {'py-6': !dense}, 'headerCell']">
                    </th>
                    <th class="headerCell">Mannschaft</th>
                    <td class="headerCell">SP</td>
                    <th class="headerCell pl-4 pr-1 text-right">S</th>
                    <th class="headerCell px-3">U</th>
                    <th class="headerCell pr-4 pl-1 text-left">N</th>
                    <td class="headerCell pr-0 pl-2 text-center">SaP</td>
                    <td class="headerCell">Diff</td>
                    <td class="headerCell pr-0 pl-2 text-center">Map</td>
                    <td class="headerCell">Diff</td>
                    <td class="headerCell">Pkt</td>
                </tr>
            </template>
            <template v-slot:item="{ index, item }">
                <tr :class="isPrint?'':saison.tabellenFarben[item.pos]">
                    <td class="pr-2">{{item.pos}}</td><!--{{index+1}} {{getPos(index, item)}}-->
                    <td class="px-2">{{item.name}}</td>
                    <td class="text-center borderRight">{{item.spiele}}</td>
                    <td class="text-right pl-2 pr-1">{{item.siege}}</td>
                    <td class="text-center px-3">{{item.unentschieden}}</td>
                    <td class="text-left pr-2 pl-1 borderRight">
                                            {{item.niederlagen}}</td>
                    <td class="text-center pr-0">{{item.satzpunkte}}</td>
                    <td class="text-center borderRight">
                                            {{item.satzpunkteDiff}}</td>
                    <td class="text-center pr-0">{{item.mannschaftsPunkte}}</td>
                    <td class="text-center borderRight">
                                            {{item.mannschaftsPunkteDiff}}</td>
                    <td class="text-center font-weight-bold">{{item.tabPkt}}</td>
                </tr>
            </template>
            <template v-slot:no-data>
                Es wurden noch keine Mannschaften und Spiele erfasst!
            </template>
        </v-data-table>
        <!--<p v-for="(mannschaft, i) in saison.local.tabelle" :key="i">
            {{mannschaft}}
        </p>-->
        <tabelle-legend v-if="!hideLegend"></tabelle-legend>
    </div>
</template>

<script>
    import TabelleLegend from "./tabelleLegend";

    export default {
        components: {TabelleLegend},
        name: "tabelle",
        props: ['saison', 'hideLegend', 'dense', 'isPrint'],
        computed: {
            nrOfTeams(){ return this.saison ? this.saison.local.tabelle.length : 0; }
        },
        data: () => ({
            headers: [   { text: '', value: 'pos', sortable: false},
                { text: 'Mannschaft', value: 'name', sortable: false},
                { text: 'SP', value: 'spiele', sortable: false, align: 'center'},
                { text: 'S', value: 'siege', sortable: false, align: 'center'},
                { text: 'U', value: 'unentschieden', sortable: false, align: 'center'},
                { text: 'N', value: 'niederlagen', sortable: false, align: 'center'},
                { text: 'SaP', value: 'satzpunkte', sortable: false, align: 'center'},
                { text: 'Diff', value: 'satzpunkteDiff', sortable: false, align: 'center'},
                { text: 'MaP', value: 'mannschaftsPunkte', sortable: false, align: 'center'},
                { text: 'Diff', value: 'mannschaftsPunkteDiff', sortable: false, align: 'center'},
                { text: 'Pkt', value: 'tabPkt', sortable: false, align: 'center'},
            ]
        }),
        /*methods: {
            getPos(index, item){
                if ( index === 0 || (index > 0 &&
                     item.tabPkt !== this.saison.local.tabelle[index-1].tabPkt) ) {
                    return index + 1
                } else {
                    return ''
                }
            },
        },*/
    }
</script>

<style scoped>
    .borderRight {border-right: solid 1px lightgrey}
    .headerCell { font-size: 12px; font-weight: 600; color: #777;
        border-bottom: solid #ddd 1px;}
</style>